export const SCREEN_RULE = 'showtime.comscore.exhibitor.theatrePerspective';
export const PAGE_PATH = 'theatres';
export const DEFAULT_PAGE_SCREEN_PATH = 'films';